var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.92 3.414A.746.746 0 0020.25 3H3.75a.746.746 0 00-.67.415.748.748 0 00.07.785l6.6 8.867V19.5a1.51 1.51 0 001.5 1.5c.325 0 .64-.105.9-.3l1.5-1.125c.377-.284.6-.728.6-1.2v-5.308l6.6-8.867a.75.75 0 00.07-.786zM7.064 4.65l2.954 3.938a.368.368 0 01.075.224v.938a.375.375 0 01-.675.225L5.715 5.1a.375.375 0 01.3-.6h.75c.117 0 .227.056.298.15z",
    fill: "#FFF"
  }))));
}
export default SvgFilter;